module.exports = __webpack_public_path__ + "static/img/Cross.d513e6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/contact/Cross.png
// module id = pO4p
// module chunks = 1